import React, { Component } from 'react';

const openStoryShare = (url, text, device) => {
  if (device.getIn(['device', 'type']) === 'mobile') {
    Kakao.Story.open({ url, text });
  } else {
    Kakao.Story.share({ url, text });
  }
}

export default class KakaoStoryShareButton extends Component {
  render() {
    const { url, device } = this.props;
    return (
      <button type="button" className="btn_sns btn_story" onClick={() => openStoryShare(url, '', device)}>
        <span className="ico_plus" />카카오스토리
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/KakaoStoryShareButton/index.js